import React from "react";

import {
  MapMarkerDisplayTypeEnum,
  MapMarkerLocationTypeEnum,
} from "custom-types/StoreLocator";

import { MarkerBadge, MarkerCircle, MarkerPin } from "./MarkerShapes";

type Props = {
  displayType: MapMarkerDisplayTypeEnum;
  locationType: MapMarkerLocationTypeEnum | null;
  hasLogo?: boolean;
};

type SubcomponentProps = {
  locationType: MapMarkerLocationTypeEnum | null;
  hasLogo?: boolean;
};

function ProminentImageContainerMarker() {
  return <MarkerPin fill="#FFCD00" stroke="#FFF" />;
}

function ImageContainerMarker({ hasLogo, locationType }: SubcomponentProps) {
  // since the fallback images are already icons, only show badge if marker has a logo
  const showDeliveryBadge =
    !!hasLogo && locationType === MapMarkerLocationTypeEnum.Delivery;

  if (showDeliveryBadge) {
    return (
      <>
        <MarkerCircle fill="#333" />
        <MarkerBadge iconFilePath="scooter_filled.svg" />
      </>
    );
  }
  return <MarkerCircle fill="#017c6b" />;
}

function ProminentIconMarker() {
  return <MarkerPin fill="#017c6b" strokeWidth={0} />;
}

function IconMarker() {
  return <MarkerCircle fill="#81a39c" />;
}

export default function DynamicMarker({
  displayType,
  hasLogo,
  locationType = null,
}: Props) {
  switch (displayType) {
    case MapMarkerDisplayTypeEnum.ProminentImageContainer:
      return <ProminentImageContainerMarker />;
    case MapMarkerDisplayTypeEnum.ImageContainer:
      return (
        <ImageContainerMarker hasLogo={hasLogo} locationType={locationType} />
      );
    case MapMarkerDisplayTypeEnum.ProminentIcon:
      return <ProminentIconMarker />;
    default:
      return <IconMarker />;
  }
}
